import BookDemoForm, { getServerSidePropsFunc } from '../bookafreehomedemo';
export default BookDemoForm;
export const getServerSideProps = getServerSidePropsFunc('/watersoftener/book-a-demo');
